import { Env } from '@alkem/sdk-dashboard';

export const getEnv = () => Env.getEnv().env;
